import { invokeApi } from "../bl_libs/invokeApi";
import { getAccessToken } from "../utils/authStorage";

export const contact_us_api = async (data) => {
  const requestObj = {
    path: `api/partner/contact_us`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${getAccessToken()}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
